import { render, staticRenderFns } from "./CSS.vue?vue&type=template&id=247f4df1&"
import script from "./CSS.vue?vue&type=script&lang=js&"
export * from "./CSS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports